module.exports = __webpack_public_path__ + "static/media/BioDigestores.f65edcba.jpg";